<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">まもりこサービス対応機器「人感センサー」購入のお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li class="current"><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->

        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong> 本サイトについて </strong>
                </h2>
                <div class="col7 input_area">
                    <h3 class="strong big-16 mb-05em">本サイトでは以下のお申込みが可能です。</h3>
                    <ul class="list-disc">
                        <li>まもりこサービス対応機器「人感センサー」の購入</li>
                    </ul>
                    <br />
                    <h3 class="strong big-16 mb-05em">一度のお申し込みで複数台の購入はできません。必要分お申し込みをお願いします。</h3>

                    <hr class="thick" />

                    <h3 class="strong big-16 mb-05em">お申込みに必要なもの</h3>
                    <ul class="list-disc">
                        <li>クレジットカード（VISA,Master,JCB,AMX,Diners）</li>
                    </ul>

                    <hr class="thick" />

                    <h3 class="strong big-16 mb-05em">個人情報の取扱について</h3>
                    <dl>
                        <dd>
                            <p>個人情報保護方針および特定商取引に基づく表記(<a href="https://www.necolico.co.jp/privacypolicy/" target="_blank">外部リンク</a>)</p>
                        </dd>
                    </dl>
                    <hr class="thick" />
                </div>

                <h2 class="col5 section_title">
                    <strong> 商品・サービス内容 </strong>
                </h2>
                <div class="col7 input_area">
                    <ul class="default_list mt-0">
                        <li>
                            <span>商品・サービス名</span>
                            <span>まもりこサービス対応機器 人感センサー</span>
                        </li>
                        <li>
                            <span>料金</span>
                            <span>￥9,900-(税込)</span>
                        </li>
                        <li>
                            <span>支払い周期</span>
                            <span>一括払い</span>
                        </li>
                    </ul>
                    <div id="image-wrapper">
                        <img src="/img/MamolicoNCS02D02Jp.png" alt="まもりこ (ACアダプタ同梱版)" />
                    </div>
                    <br /><br />
                    <h3 class="strong big-16 mb-05em">セット内容(詳細)</h3>
                    <p>
                        1）人感センサー本体<br />
                        2）ACアダプタ<br />
                        3）USB TypeCケーブル（1.5m）<br />
                        4）専用スタンド<br />
                        5）固定用両面テープ<br />
                        6）固定用ピン<br />
                        7）取扱説明書<br />
                    </p>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong> 注意事項 </strong>
                </h2>
                <div class="col7 input_area">
                    <ul class="list-disc small">
                        <li>本製品の使用にあたり、専用スマートフォンアプリ「まもりこ2」のインストールおよび同アプリから高齢者みまもりサービス「まもりこ」の契約が必要です。</li>
                        <li>高齢者みまもりサービス「まもりこ」は、本製品1台につき1契約が必要であり、また1契約につき月額利用料550円（税抜）が必要となります（初月のみ無料です）。</li>
                        <li>本製品は、人体の動きを赤外線の変化として捉える仕組み上、周囲環境や設置条件により、遮蔽物・日射等の影響を受け、検知しない場合や、誤検知する場合があります。</li>
                        <li>本製品にはSIMカードが内蔵されています。本SIMカードは高齢者みまもりサービス「まもりこ」以外の用途で利用することはできません。</li>
                        <li>通信可能LTEエリアはソフトバンクおよびauの対応サービスエリアに準じます。3Gおよび5Gの通信には対応していません。</li>
                        <li>本製品は、サービスエリア内でも電波の届かない場所（地下等）では通信できません。また、電波状態の悪い場所では通信できない場合があります。</li>
                        <li>電波状態が悪い場合、本製品到着日より7日以内にお客様からお申し出をいただいた場合に限り、返品をお受けいたします。</li>
                        <li>サービス契約の解約はネコリコポータル（<a href="https://portal.necolico.jp" target="_blank">https://portal.necolico.jp</a>）よりいつでも行えます。</li>
                        <li>本製品はサービス解約後、使用できなくなります。</li>
                        <li>お支払いはクレジットカードのみご利用いただけます。利用できるカードブランドは、VISA、Master、JCB、アメリカン・エキスプレス、ダイナーズです。</li>
                        <li>返金の手続きはクレジット会社を通じて行います。</li>
                        <li>保証期間は1年です。本製品を購入された日から起算して1年以内に材料または製造技術上の瑕疵が発見された場合、新品もしくは再生された同等品による交換、または購入代金の一部もしくは全額の返金のいずれかを行います。なお、事故、誤使用、懈怠、火災、改変、第三者による修理（お客様ご自身による修理も含みます）、その他の外的要因による損傷については、保証の対象外となります。</li>
                    </ul>
                    <hr class="thick" />
                </div>
                <h2 class="col5 section_title">
                    <strong> 申込みを始める </strong>
                </h2>
                <div class="col7 input_area">
                    <p>
                        初めてご利用の方は「アカウントを作成して購入する」をご選択ください。
                        <br />
                        ネコリコアカウントを作成いただくと、いつでも請求書・領収書をご確認いただけます。
                        <br />
                        アカウントをお持ちの方は「ログインして購入する」をご選択ください。
                        <br />
                        <br />
                        アカウントを作成せずに購入をご希望の方は、「アカウントを作成せずに購入」を選択してください。
                    </p>
                    <p class="submit_btn">
                        <input type="submit" @click="signup" value="アカウントを作成して購入する" onsubmit="return false;" />
                    </p>
                    <p class="submit_btn">
                        <input type="submit" @click="login" value="ログインして購入する" onsubmit="return false;" />
                    </p>
                    <p class="submit_btn">
                        <input type="submit" @click="withoutLogin" value="アカウントを作成せずに購入する" onsubmit="return false;" />
                    </p>
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    created() {
        document.isWithoutLogin = false;
        document.token = "";
    },
    methods: {
        formatCommafy: function (val) {
            return this.$utils.commafy(val);
        },
        signup: function () {
            // 共通ログイン画面（新規登録導線）へ遷移
            const query = new URLSearchParams({
                np: document.np,
                auth: "signup"
            });
            location.href = `/mamolico/nc-s02d02jp-store?${query.toString()}`;
        },
        login: function () {
            // 共通ログイン画面（ログイン導線）へ遷移
            const query = new URLSearchParams({
                np: document.np,
                auth: "login"
            });
            location.href = `/mamolico/nc-s02d02jp-store?${query.toString()}`;
        },
        withoutLogin: function () {
            this.$emit("showSpinner", "処理中");
            this.$authRequest("withoutLogin", {}, (res) => {
                this.$emit("hideSpinner");
                // トークンをdocumentに保持する
                document.token = res.data.token;
                document.isWithoutLogin = true;

                this.$router.push({
                    name: "CouponForm"
                });
            });
        }
    },
    data: function () {
        return {};
    }
};
</script>

<style scoped>
.flow-item {
    width: 100%;
    text-align: center;
}
.flow-item :first-child {
    background: #ccd100;
    border: solid 2px #ccd100;
    border-bottom: none;
    position: relative;
}
.flow-item :first-child:before {
    content: "";
    width: calc(100% + 4px);
    height: 20px;
    position: absolute;
    bottom: -20px;
    left: -2px;
    background: linear-gradient(to top right, transparent 50%, /* black 30%, */ #ccd100 calc(50% + 2px)) top left/ 50% 100% no-repeat,
        linear-gradient(to top left, transparent 50%, /* black 30%, */ #ccd100 calc(50% + 2px)) top right / 50% 100% no-repeat;
}
.small {
    line-height: 2;
}

#image-wrapper {
    text-align: center;
    width: 100%;
}

#image-wrapper img {
    /* 人感センサの画像が縦長で画面を占有してしまうため、振動センサと同じくらいの高さに抑える */
    max-height: 300px;
}
</style>
